// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取投顾老师详情 GET /analyst */
export async function analystUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.analystUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultSsAnalystInfo>('/analyst', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取案例频道对应老师 GET /analyst/getChannelAnalystList */
export async function analystGetChannelAnalystListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.analystGetChannelAnalystListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListAnalystInfoResp>('/analyst/getChannelAnalystList', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取投顾老师列表 GET /analyst/list */
export async function analystListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.analystListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListSsAnalystInfo>('/analyst/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
